<script>
import Undo from './controls/Undo.svelte';
import Redo from './controls/Redo.svelte';
import Shortcuts from './controls/Shortcuts.svelte';
import ExportFile from './controls/ExportFile.svelte';
import ImportFile from './controls/ImportFile.svelte';
import AddEvent from './controls/AddEvent.svelte';
import RemoveEvent from './controls/RemoveEvent.svelte';
import AlignLeft from './controls/AlignLeft.svelte';
import AlignCenter from './controls/AlignCenter.svelte';
import AlignRight from './controls/AlignRight.svelte';
import WritingMode from './controls/WritingMode.svelte';
import Position from './controls/Position.svelte';
import PositionLineUp from './controls/PositionLineUp.svelte';
import PositionLineDown from './controls/PositionLineDown.svelte';
import Copy from './controls/Copy.svelte';
import Cut from './controls/Cut.svelte';
import Paste from './controls/Paste.svelte';
import ShiftWordBack from './controls/ShiftWordBack.svelte';
import ShiftWordForward from './controls/ShiftWordForward.svelte';
import ShiftLineBack from './controls/ShiftLineBack.svelte';
import ShiftLineForward from './controls/ShiftLineForward.svelte';
import Split from './controls/Split.svelte';
import Merge from './controls/Merge.svelte';
import Expand from './controls/Expand.svelte';
import Compress from './controls/Compress.svelte';
import AutoFormatButton from './controls/AutoFormatButton.svelte';
import SnapToStart from './controls/SnapToStart.svelte';
import SnapToEnd from './controls/SnapToEnd.svelte';

let { items = [], ariaLabel = '', slotClass = '' } = $props();

const ITEM_COMPONENTS = {
    undo: Undo,
    redo: Redo,
    shortcuts: Shortcuts,
    exportFile: ExportFile,
    importFile: ImportFile,
    addEvent: AddEvent,
    removeEvent: RemoveEvent,
    alignLeft: AlignLeft,
    alignCenter: AlignCenter,
    alignRight: AlignRight,
    writingMode: WritingMode,
    position: Position,
    positionLineUp: PositionLineUp,
    positionLineDown: PositionLineDown,
    copy: Copy,
    cut: Cut,
    paste: Paste,
    shiftWordBack: ShiftWordBack,
    shiftWordForward: ShiftWordForward,
    shiftLineBack: ShiftLineBack,
    shiftLineForward: ShiftLineForward,
    split: Split,
    merge: Merge,
    expand: Expand,
    compress: Compress,
    autoFormat: AutoFormatButton,
    snapToStart: SnapToStart,
    snapToEnd: SnapToEnd,
};
</script>

<ul class={["nav", "navbar-nav", "cc-toolbar-slot", slotClass]} aria-label={ariaLabel}>
    {#each items as item (item.key)}
        {#if item.type === "separator"}
            <div class="vr align-self-center" role="separator"></div>
        {:else}
            {@const Comp = ITEM_COMPONENTS[item.id]}
            {#if Comp}
                <Comp />
            {/if}
        {/if}
    {/each}
</ul>
